"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumns = void 0;
const react_intl_1 = require("react-intl");
const authored_columns_1 = require("../../composite/evidence/authored-evidence/authored-columns");
const table_cells_1 = require("../../composite/table/table-cells");
const table_filter_cells_1 = require("../../composite/table/table-filter-cells");
const alog_api_1 = require("./alog-api");
function useColumns() {
    const intl = (0, react_intl_1.useIntl)();
    const { authoredColumns } = (0, authored_columns_1.useAuthoredColumns)();
    return [
        {
            datakey: 'sourceType',
            sortkey: 'sourceType.name',
            filterkey: 'sourceType.id',
            name: intl.formatMessage({
                id: 'EAS_ALOG_COLUMN_SOURCE_TYPE',
                defaultMessage: 'Typ zdroje',
            }),
            width: 150,
            CellComponent: table_cells_1.TableCells.TextCell,
            FilterComponent: table_filter_cells_1.TableFilterCells.useFilterSelectCellFactory(alog_api_1.useEventSourceTypes),
            valueMapper: table_cells_1.TableCells.useSelectCellFactory(alog_api_1.useEventSourceTypes),
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'source',
            name: intl.formatMessage({
                id: 'EAS_ALOG_COLUMN_SOURCE',
                defaultMessage: 'Zdroj',
            }),
            width: 100,
            CellComponent: table_cells_1.TableCells.TextCell,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'module.name',
            name: intl.formatMessage({
                id: 'EAS_ALOG_COLUMN_MODULE',
                defaultMessage: 'Modul',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.TextCell,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'message',
            name: intl.formatMessage({
                id: 'EAS_ALOG_COLUMN_MESSAGE',
                defaultMessage: 'Zpráva',
            }),
            width: 300,
            CellComponent: table_cells_1.TableCells.TextCell,
            sortable: false,
            filterable: true,
        },
        {
            datakey: 'ipAddress',
            name: intl.formatMessage({
                id: 'EAS_ALOG_COLUMN_IP_ADDRESS',
                defaultMessage: 'IP adresa',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.TextCell,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'user',
            displaykey: 'user.name',
            sortkey: 'user.name',
            filterkey: 'user.name',
            name: intl.formatMessage({
                id: 'EAS_ALOG_COLUMN_USER',
                defaultMessage: 'Uživatel',
            }),
            width: 150,
            CellComponent: table_cells_1.TableCells.TextCell,
            sortable: true,
            filterable: true,
        },
        ...authoredColumns,
    ];
}
exports.useColumns = useColumns;
//# sourceMappingURL=alog-columns.js.map